export { default as LifestylesGammasFilterBadge } from './LifestylesGammasFilterBadge';
